import { h, Component, Fragment } from "preact";
import Clock from "./clock";
import Session from "../../utils/session";
import MoneyFormatter from "../../utils/money-formatter";
import PageDataFeed from "../../../../services/page-data-feed";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Observer from "../../utils/observer";
import { route } from "preact-router";
import Config from "../../../../services/config";
import User from "../../../../services/user";
import Localization from "../../utils/localization";
import FacebookLogin from "../../../../services/facebook-login";

import * as I from "../../utils/icons";
import AwrabetUserTopbarSection, {
	UserSection as AwrabetUserSection,
	AffiliateMenu as AwrabetAffiliateMenu,
	LangDropdown as AwrabetLangDropdown,
} from "../../../awrabet/desktop-components/site/user-topbar-section";
import { TelegramButton } from "../../../../services/telegram/openidLogin";

export default class UserTopbarSection extends AwrabetUserTopbarSection {
	render() {
		return (
			<div id="user-bar" class="header-user-bar text-sm flex h-9 w-full border-b border-b-harifzinc-950">
				<div class="w-1/5 grow flex items-center">
					<LangDropdown />
					<Clock />
				</div>
				<div class="w-4/5 text-right grow flex py-1">
					<UserSection />
				</div>
			</div>
		);
	}
}

export class UserSection extends AwrabetUserSection {
	render() {
		const FacebookLoginUrl = !!Config.betting["fb-login-url"]
			? Config.betting["fb-login-url"]
			: null;
		const user = User.data;

		if (user) {
			return (
				<div
					id="login-form"
					class="flex items-stretch w-full justify-end gap-1 px-1"
				>
					{User.isPlayer() && (
						<div class="flex rounded items-center">
							{/* User Info */}
							<div class="inline-block px-2">
								<I.UserIcon class="h-6 inline-block" />{" "}
								<span class="text-xs">{user.username}</span>
							</div>
							{!!this.state.showbalance && (
								<div class="inline-block px-2">
									<I.MoneyIcon class="h-4 inline-block" />{" "}
									<div class="text-xs inline-block">
										<MoneyFormatter
											value={user.account.balance}
											currency={user.account.currency}
										/>
									</div>
								</div>
							)}
							<a
								href="javascript:void(0);"
								class="hide-balance-button"
								onClick={(e) => this.toggleBalanceVisibility()}
								title={
									!!this.state.showbalance
										? window.Translation(msg`Nascondi Saldo`)
										: window.Translation(msg`Mostra Saldo`)
								}
							>
								{!!this.state.showbalance ? (
									<I.EyeIcon class="h-4 inline-block" />
								) : (
									<I.EyeSlashIcon class="h-4 inline-block" />
								)}
							</a>
						</div>
					)}

					{User.isAffiliate() && <AffiliateMenu />}

					<div class="ml-2 flex items-stretch gap-1">
						{!user.manager && (
							<Fragment>
								<BadgeRect onClick={(e) => this.openUserMenu("transactions")}>
									<I.TransactionsIcon class="h-full" />
								</BadgeRect>
								<BadgeRect onClick={(e) => this.openUserMenu("bets")}>
									<I.BetsIcon class="h-full" />
								</BadgeRect>
								<BadgeRect onClick={(e) => this.openUserMenu("cashouts")}>
									<I.CashoutIcon class="h-full" />
								</BadgeRect>
							</Fragment>
						)}
						<BadgeRect
							onClick={(e) => this.openUserMenu("messages")}
							class="flex items-center gap-1"
						>
							<I.MessageIcon class="h-4" />{" "}
							<div class="font-bold main-color leading-none">2</div>
						</BadgeRect>
						<BadgeRect onClick={(e) => this.openUserMenu("profile")}>
							<I.UserIcon class="h-full" />
						</BadgeRect>
					</div>

					{!!user.manager && (
						<div class="flex items-stretch gap-1 pl-2 border-l">
							{/* Operator Menù */}
							<BadgeRect onClick={(e) => this.openManagerPanel()}>
								<I.PlayersIcon class="h-full" />
							</BadgeRect>
						</div>
					)}

					{!!user.club && !user.manager && (
						<div class="flex items-stretch gap-1 pl-2 border-l">
							{/* Operator Menù */}
							<BadgeRect onClick={(e) => this.openUserMenu("dashboard")}>
								<I.PlayersIcon class="h-full" />
							</BadgeRect>
							<BadgeRect onClick={(e) => this.openUserMenu("reports")}>
								<I.ReportsIcon class="h-full" />
							</BadgeRect>
						</div>
					)}

					<UserButton
						type="button"
						value={window.Translation(msg`Logout`)}
						onClick={(e) => this.logout()}
					/>
				</div>
			);
		}

		return (
			<form
				id="login-form"
				method="post"
				class="flex items-stretch w-full justify-end  px-1"
				onSubmit={(e) => {
					e.preventDefault();
					this.login();
				}}
			>
				{/* Username */}
				<label for="login-user" class="relative">
					<div class="absolute text-xs top-0 bottom-0 flex items-center pl-0.5">
						+251 (0)
					</div>
					<input
						id="login-user"
						type="text"
						autocomplete="tel-national"
						placeholder={window.Translation(msg`Number`)}
						class="text-slate-100 bg-harif-950 w-32 py-1 pl-12 mr-px focus:outline-none focus:border-custom-orange focus:ring-1 focus:ring-custom-orange"
						onInput={(e) =>
							this.setState({
								loginform: {
									username: e.target.value,
									password: this.state.loginform.password,
								},
							})
						}
						value={this.state.loginform.username}
					/>
				</label>
				{/* Password */}
				<label for="login-pass">
					<input
						id="login-pass"
						type="password"
						autocomplete="current-password"
						placeholder={window.Translation(msg`Password`)}
						class="text-slate-100 bg-harif-950 w-32 py-1  focus:outline-none focus:border-custom-orange focus:ring-1 focus:ring-custom-orange"
						onInput={(e) =>
							this.setState({
								loginform: {
									username: this.state.loginform.username,
									password: e.target.value,
								},
							})
						}
						value={this.state.loginform.password}
					/>
				</label>

				{/* Login and Register Buttons */}
				<div class="flex gap-1 ml-2">
					<UserButton type="submit" value={window.Translation(msg`Accedi`)} />
					<UserButton
						type="button"
						value={window.Translation(msg`Registrati`)}
						onClick={(e) => this.openSignupForm()}
					/>
				</div>
				{!!FacebookLoginUrl && (
					<div>
						<FacebookLogin url={FacebookLoginUrl} />
					</div>
				)}
				{!!Config.telegramLogin &&
					<TelegramButton
						class="rounded-xs p-0 h-full aspect-square ml-1"
						clientId={Config.telegramLogin}
						shape="square"
						iconOnly={true}
						onSuccess={e => {
							PageDataFeed.rerender();
						}}
					/>}
			</form>
		);
	}
}

function UserButton({ ...props }) {
	return (
		<input
			class="form-button max-w-max min-h-[70%] py-1 px-5 inline-block hover:cursor-pointer bg-custom-orange text-black text-[14px] uppercase font-bold"
			{...props}
		/>
	);
}


export class AffiliateMenu extends AwrabetAffiliateMenu {
	render() {
		const AffiliateAmounts = User.affiliateamounts();
		const user = User.data;

		return (
			<div class="inline-block relative mr-2" style="width:236px;height:19px;">
				<div class="absolute w-full text-left z-50">
					<div
						class={
							"flex flex-col rounded px-2 py-1 bg-blue-whale-900 text-slate-100 w-59" +
							(!!this.state.showbalance ? " shadow-2xl" : "")
						}
					>
						<div class="flex shrink-0 h-full">
							<div class="w-full px-2 h-full">
								<I.UserIcon class="h-4 inline-block" />{" "}
								<span class="text-xs">{user.username}</span>
							</div>
							<a
								href="javascript:void(0);"
								class="hide-balance-button"
								onClick={(e) => this.toggleBalanceVisibility()}
								title={
									!!this.state.showbalance
										? window.Translation(msg`Nascondi Saldo`)
										: window.Translation(msg`Mostra Saldo`)
								}
							>
								<I.UpArrowIcon
									class={
										"h-4 transition-transform " +
										(this.state.showbalance ? "" : "rotate-180")
									}
								/>
							</a>
						</div>
						{!!this.state.showbalance && !!AffiliateAmounts && (
							<Fragment>
								<div class="flex mt-2 py-1 items-center text-xs border-t">
									<span class="w-full">
										<Trans>Disponibilità</Trans>
									</span>
									<span class="shrink-0 px-2">
										<MoneyFormatter
											currency={AffiliateAmounts.currency}
											value={AffiliateAmounts.balance}
										/>
									</span>
								</div>
								<div class="flex py-1 items-center text-xs border-t">
									<span class="w-full text-xs">
										<Trans>Saldo</Trans>
									</span>
									<span class="shrink-0 px-2">
										<MoneyFormatter
											currency={AffiliateAmounts.currency}
											value={AffiliateAmounts.saldo}
										/>
									</span>
								</div>
								<div class="flex py-1 items-center text-xs border-t">
									<span class="w-full text-xs">
										<Trans>Fido</Trans>
									</span>
									<span class="shrink-0 px-2">
										<MoneyFormatter
											currency={AffiliateAmounts.currency}
											value={AffiliateAmounts.fido}
										/>
									</span>
								</div>
								<div class="flex py-1 items-center text-xs border-t">
									<span class="w-full text-xs">
										<Trans>Disp. Giocatori</Trans>
									</span>
									<span class="shrink-0 px-2">
										<MoneyFormatter
											currency={AffiliateAmounts.currency}
											value={AffiliateAmounts.liquido}
										/>
									</span>
								</div>
								<div class="flex py-1 items-center text-xs border-t">
									<span class="w-full">
										<Trans>Importo Circolante</Trans>
									</span>
									<span class="shrink-0 px-2">
										<MoneyFormatter
											currency={AffiliateAmounts.currency}
											value={AffiliateAmounts["saldo-netto"]}
										/>
									</span>
								</div>
							</Fragment>
						)}
					</div>
				</div>
			</div>
		);
	}
}

const languageImages = {
	en: require("url:../../assets/img/lang/en.png"),
	it: require("url:../../assets/img/lang/it.png"),
	es: require("url:../../assets/img/lang/es.png"),
};

export class LangDropdown extends AwrabetLangDropdown {
	render() {
		const currentLang = Localization.data.currentLanguage;

		return (
			<div
				class={
					"bg-harif-950 w-16 mx-2 px-2 py-1 inline-block relative " +
					(!!this.state.showlanglist ? "rounded-t" : "rounded")
				}
			>
				<div class="flex w-full items-center">
					<img
						src={languageImages[currentLang]}
						alt={currentLang}
						class="w-5 h-5 inline-block"
					/>
					<a
						class="w-full text-center"
						href="javascript:void(0);"
						onClick={(e) =>
							this.setState({ showlanglist: !this.state.showlanglist })
						}
					>
						{currentLang}
					</a>
				</div>
				{!!this.state.showlanglist && (
					<div class="absolute top-7 left-0 w-full bg-harif-950 flex flex-col items-start justify-center rounded-b">
						<a
							href="?lang=en"
							class="w-full rounded px-2 py-1 flex items-center justify-center hover:bg-harif-925"
						>
							<img
								src={languageImages.en}
								alt="en"
								class="w-5 h-5 inline-block"
							/>
							<span class="w-full text-center">en</span>
						</a>
						<a
							href="?lang=it"
							class="w-full rounded px-2 py-1 flex items-center justify-center hover:bg-harif-925"
						>
							<img
								src={languageImages.it}
								alt="it"
								class="w-5 h-5 inline-block"
							/>
							<span class="w-full text-center">it</span>
						</a>
						<a
							href="?lang=es"
							class="w-full rounded px-2 py-1 flex items-center justify-center hover:bg-harif-925"
						>
							<img
								src={languageImages.es}
								alt="es"
								class="w-5 h-5 inline-block"
							/>
							<span class="w-full text-center">es</span>
						</a>
					</div>
				)}
			</div>
		);
	}
}

function BadgeRect({ children, onClick, ...props }) {
	return (
		<a
			onClick={onClick}
			class={
				"bg-harif-950 text-slate-50 hover:bg-hrf-900 cursor-pointer h-full px-2 py-1.5 rounded text-center " +
				props["class"]
			}
		>
			{children}
		</a>
	);
}
